__turbopack_context__.v({
  "arrowCircleSpan": "NsatBanner-module-scss-module__vyQwuG__arrowCircleSpan",
  "brandName": "NsatBanner-module-scss-module__vyQwuG__brandName",
  "candidateName": "NsatBanner-module-scss-module__vyQwuG__candidateName",
  "card": "NsatBanner-module-scss-module__vyQwuG__card",
  "content": "NsatBanner-module-scss-module__vyQwuG__content",
  "cup": "NsatBanner-module-scss-module__vyQwuG__cup",
  "cupOuter": "NsatBanner-module-scss-module__vyQwuG__cupOuter",
  "descDesktop": "NsatBanner-module-scss-module__vyQwuG__descDesktop",
  "descIcon": "NsatBanner-module-scss-module__vyQwuG__descIcon",
  "descMobile": "NsatBanner-module-scss-module__vyQwuG__descMobile",
  "description": "NsatBanner-module-scss-module__vyQwuG__description",
  "disclaimer": "NsatBanner-module-scss-module__vyQwuG__disclaimer",
  "disclaimermob": "NsatBanner-module-scss-module__vyQwuG__disclaimermob",
  "firstLetter": "NsatBanner-module-scss-module__vyQwuG__firstLetter",
  "formWrapper": "NsatBanner-module-scss-module__vyQwuG__formWrapper",
  "imgWrap": "NsatBanner-module-scss-module__vyQwuG__imgWrap",
  "infoBox": "NsatBanner-module-scss-module__vyQwuG__infoBox",
  "infoIcon": "NsatBanner-module-scss-module__vyQwuG__infoIcon",
  "infoItem": "NsatBanner-module-scss-module__vyQwuG__infoItem",
  "infoText": "NsatBanner-module-scss-module__vyQwuG__infoText",
  "infoValue": "NsatBanner-module-scss-module__vyQwuG__infoValue",
  "mwebSecure": "NsatBanner-module-scss-module__vyQwuG__mwebSecure",
  "perRunnerUP": "NsatBanner-module-scss-module__vyQwuG__perRunnerUP",
  "photo": "NsatBanner-module-scss-module__vyQwuG__photo",
  "program": "NsatBanner-module-scss-module__vyQwuG__program",
  "rankWinners": "NsatBanner-module-scss-module__vyQwuG__rankWinners",
  "registerationsWrap": "NsatBanner-module-scss-module__vyQwuG__registerationsWrap",
  "registrationsClosed": "NsatBanner-module-scss-module__vyQwuG__registrationsClosed",
  "runnerUp": "NsatBanner-module-scss-module__vyQwuG__runnerUp",
  "scholorship": "NsatBanner-module-scss-module__vyQwuG__scholorship",
  "section": "NsatBanner-module-scss-module__vyQwuG__section",
  "subtitle": "NsatBanner-module-scss-module__vyQwuG__subtitle",
  "subtitleAccent": "NsatBanner-module-scss-module__vyQwuG__subtitleAccent",
  "successDesc": "NsatBanner-module-scss-module__vyQwuG__successDesc",
  "successTitle": "NsatBanner-module-scss-module__vyQwuG__successTitle",
  "successWrapper": "NsatBanner-module-scss-module__vyQwuG__successWrapper",
  "svgContainer": "NsatBanner-module-scss-module__vyQwuG__svgContainer",
  "testDate": "NsatBanner-module-scss-module__vyQwuG__testDate",
  "testDateInner": "NsatBanner-module-scss-module__vyQwuG__testDateInner",
  "title": "NsatBanner-module-scss-module__vyQwuG__title",
  "titleAccent": "NsatBanner-module-scss-module__vyQwuG__titleAccent",
});
